import { WIDGET_FORM_INPUT_CUSTOM_FIELDS } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const CustomFieldsInputWidget: WidgetRegistryEntry = {
  name: WIDGET_FORM_INPUT_CUSTOM_FIELDS,
  component: () => import("./custom-fields-input-widget.component").then((m) => m.CustomFieldsInputWidgetComponent)
};
